var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 12.6667H7.9987V8.62773L5.33203 6.30268L2.66536 8.62773V12.6667H4.66536V10H5.9987V12.6667ZM13.9987 14H1.9987C1.63051 14 1.33203 13.7015 1.33203 13.3333V8.32453C1.33203 8.13187 1.41537 7.9486 1.56058 7.822L3.9987 5.69623V2.66667C3.9987 2.29848 4.29718 2 4.66536 2H13.9987C14.3669 2 14.6654 2.29848 14.6654 2.66667V13.3333C14.6654 13.7015 14.3669 14 13.9987 14ZM10.6654 7.33333V8.66667H11.9987V7.33333H10.6654ZM10.6654 10V11.3333H11.9987V10H10.6654ZM10.6654 4.66667V6H11.9987V4.66667H10.6654ZM7.9987 4.66667V6H9.33203V4.66667H7.9987Z",
    fill: "#8CA2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessSite);
export default __webpack_public_path__ + "static/media/icon_business_site.2e47ccb208be10a19edb8cd6d82e5074.svg";
export { ForwardRef as ReactComponent };